import { useMemo } from "react";

export function useDeviceContext() {
  const isMobile = useMemo(() => {
    if (typeof window === "undefined") return false;

    const userAgent = window.navigator.userAgent.toLowerCase();
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent,
    );
  }, []);

  return {
    isMobile,
  };
}
